import { Component, HostListener, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import * as EASDialogError from '@fry/components/common/dialog/dialog.error';
import { DBDoc } from '@fry/lib/store';
import { EasFormGroup } from '@fry/components/common/easform';
import { BookingFileUploadDelegate } from '@fry/booking/components/bookings/booking-edit/booking-file-upload.service';
import { FileUploadControlComponentDelegate } from '@fry/components/common/file-upload-control';

export interface RefundOptionData {
    actionId: string;
    doc: DBDoc;
    actionData: any;
    group: EasFormGroup;
  }

@Component({
    selector: 'app-fill-in-fields',
    templateUrl: 'fill-in-fields.component.html',
    providers: [
        { provide: FileUploadControlComponentDelegate, useClass: BookingFileUploadDelegate },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FillInFieldsComponent {

  public submitted = false;
  public canceled = EASDialogError.UserCanceledError();

  constructor(
    public dialogRef: MatDialogRef<FillInFieldsComponent>,
    private bookingFileUploadDelegate: FileUploadControlComponentDelegate,
    @Inject(MAT_DIALOG_DATA) public data: RefundOptionData,
  ) {
    this.bookingFileUploadDelegate.setContext({ oid: data.doc._id });
  }

  onSubmit() {
    if (this.submitted) { return; }
    if (this.data.group.control.invalid) {
      this.data.group.control.markAllAsTouched();
      return;
    }
    this.submitted = true;

    const value = { [this.data.actionId]: this.data.group.getValue() };
    this.dialogRef.close(value);
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    this.dialogRef.close(this.canceled);
  }
}
